import { useEffect } from "react";

export const useEditorCanvasDimensionFromApp = ({
  appData,
  setCanvasDimension,
}) => {
  useEffect(() => {
    const bannerSize = appData?.genericInfo?.bannerSize;
    if (!bannerSize) return;

    const [width, height] = bannerSize
      .split(/x/i)
      .map((value) => parseInt(value, 10));

    if (!Number.isFinite(width) || !Number.isFinite(height)) return;

    setCanvasDimension((prev) => ({
      ...prev,
      width,
      height,
    }));
  }, [appData?.genericInfo?.bannerSize, setCanvasDimension]);
};

